import type { CSSProperties } from 'react';

export function getInputStyle(inputStyle: CSSProperties): CSSProperties {
  return {
    width: '100%',
    backgroundColor: 'var(--input-background-color, #fff)',
    borderWidth: 'var(--border-width, 1px)',
    borderColor: 'var(--border-color, #e0e0e0)',
    borderStyle: 'var(--border-style, solid)',
    borderRadius: 'var(--border-radius, 4px)',
    padding: '8px',
    '::placeholder': {
      textAlign: 'var(--text-align)',
    },
    ...inputStyle,
  } as CSSProperties;
}
